import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-distance-about',
  templateUrl: './distance-about.component.html',
  styleUrls: ['./distance-about.component.scss']
})
export class DistanceAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
